module.exports = __webpack_public_path__ + "static/media/vixonic.1c9ea4c7.jpg";